import React from 'react';
import { ctaBannerImage } from '../data/mock';

const CTABanner = () => {
  return (
    <section
      className="relative py-20 bg-cover bg-center bg-fixed"
      style={{ backgroundImage: `url(${ctaBannerImage})` }}
    >
      {/* Overlay */}
      <div className="absolute inset-0 bg-[#0a2342]/80" />

      <div className="relative max-w-4xl mx-auto px-4 text-center">
        <h2 className="text-white text-2xl md:text-4xl font-bold mb-6 leading-tight">
          Is Your Organization Prepared for<br />
          Today's Evolving Cyber Threats?
        </h2>
        <p className="text-white/80 text-lg mb-8 max-w-2xl mx-auto">
          Our security experts will assess your current posture and provide actionable recommendations to strengthen your defenses.
        </p>
        <a
          href="#contact"
          className="inline-block px-8 py-4 bg-[#0077B6] text-white font-semibold rounded-full hover:bg-[#005f8f] transition-colors uppercase tracking-wide"
        >
          Schedule Security Assessment
        </a>
      </div>
    </section>
  );
};

export default CTABanner;
